import { render } from "./AvatarUpload.vue?vue&type=template&id=4b9dcd45&scoped=true&ts=true"
import script from "./AvatarUpload.vue?vue&type=script&lang=ts"
export * from "./AvatarUpload.vue?vue&type=script&lang=ts"

import "./AvatarUpload.vue?vue&type=style&index=0&id=4b9dcd45&scoped=true&lang=css"

import exportComponent from "/buddy/uup/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-4b9dcd45"]])

export default __exports__